import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, PenTool, MessageSquare } from 'lucide-react';

const QuickActionsWidget = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Explore Scenarios',
      description: 'Browse through available scenarios to practice leadership skills.',
      icon: BookOpen,
      ghostIcon: '📚',
      color: 'purple',
      path: '/scenarios',
    },
    {
      title: 'Create Custom Scenario',
      description: 'Design your own leadership scenarios tailored to your needs.',
      icon: PenTool,
      ghostIcon: '✏️',
      color: 'green',
      path: '/create-scenario',
    },
    {
      title: 'View Past Conversations',
      description: 'Review your previous conversations and track your progress.',
      icon: MessageSquare,
      ghostIcon: '🗂️',
      color: 'yellow',
      path: '/convo',
    },
  ];

  return (
    <div className="relative bg-gray-100 shadow-inner rounded-lg p-6 overflow-hidden">
      {/* Background pattern behind everything */}
      <span
        aria-hidden="true"
        style={{
          backgroundImage: "url('/patterns/bubbles.svg')",
          backgroundSize: "100%", // Increase or decrease as needed
          opacity: 0.1            // More transparent
        }}
        className="pointer-events-none absolute inset-0 bg-repeat z-0"
      />
  
      {/* Content should be relatively positioned above */}
      <div className="relative z-10">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">Get Started Now...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {actions.map(({ title, description, icon: Icon, ghostIcon, color, path }) => (
            <div
              key={title}
              onClick={() => navigate(path)}
              className={`cursor-pointer bg-white border border-${color}-200 rounded-lg p-4 flex items-center justify-between shadow-sm hover:shadow-md transition duration-200`}
            >
              <div
                className={`w-12 h-12 rounded-md border-2 border-${color}-500 bg-${color}-50 flex items-center justify-center mr-4`}
              >
                <Icon className={`text-${color}-600 w-5 h-5`} />
              </div>
              <div className="flex-1">
                <h3 className="text-md font-semibold text-gray-800">{title}</h3>
                <p className="text-sm text-gray-600">{description}</p>
              </div>
              <div className="text-3xl text-gray-400/40 hidden sm:block select-none">
                {ghostIcon}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );  
};

export default QuickActionsWidget;
